import BaseComponent from "../components/BaseComponent";
import {
    Button,
    ButtonGroup,
    Div, FormItem,
    FormLayout, Input, NativeSelect, Panel,
    PanelHeader,
    PanelHeaderButton, Select, SimpleCell,
    SplitCol,
    SplitLayout, Switch, Textarea
} from "@vkontakte/vkui";
import {Icon24BrowserBack} from "@vkontakte/icons";
import React from "react";
import {AdaptivityContext} from "../assets/constants";
import HelpButton from "../assets/HelpButton";
import SelectObject from "../assets/SelectObject";


class BaseForm extends BaseComponent {

    constructor(props) {
        super();

        const {fields} = props
        const {item} = props
        if (item && item.id > 0) {

            Object.keys(item).map(fieldName => {
                if (!fields[fieldName]) return
                fields[fieldName].value = item[fieldName]
            })
        }

        this.state = {
            ...this.state,
            fields
        }

    }

    cmdBack = () => {
        window.postMessage({
            type: this.props.eventType,
            value: null
        })
        if (this.props.hideForm) {
            this.props.hideForm()
        }

    }
    onFieldChange = (e, fieldName) => {

        const {fields} = this.state
        const field = fields[fieldName]

        if (!field) return
        if (e.uid) {
            field.value = e
        } else if (e.currentTarget.type == 'checkbox') {
            field.value = e.currentTarget.checked ? 1 : 0
        } else {
            field.value = e.currentTarget.value
        }
        fields[fieldName] = field


        this.setState({fields})

    }

    renderInput = (fieldName, field) => {

        return <FormItem top={field.title} bottom={field.error}
                         status={field.error ? 'error' : ''}>
            <Input type={field.type} disabled={field.disabled} value={field.value}
                   onChange={e => this.onFieldChange(e, fieldName)}/>
        </FormItem>
    }
    renderTextArea = (fieldName, field) => {

        return <FormItem top={field.title} bottom={field.error}
                         status={field.error ? 'error' : ''}>
            <Textarea disabled={field.disabled} value={field.value} rows={field.rows ?? 5}
                      onChange={e => this.onFieldChange(e, fieldName)}/>
        </FormItem>
    }

    renderSelectObject = (fieldName, field) => {

        return <FormItem top={field.title} bottom={field.error}
                         status={field.error ? 'error' : ''}>
            <SelectObject
                only_btn
                size="s"
                disabled={field.disabled}
                current_user={this.props.current_user}
                app={field.app}
                act={field.act}
                params={field.params && this.props.item?.id ? field.params.replace('{self_id}', this.props.item.id) : ''}
                default={field.value}
                modal_title={field.modal_title}
                items={field.options}
                selectObject={e => this.onFieldChange(e, fieldName)}
            />
        </FormItem>
    }
    renderSelect = (fieldName, field) => {

        return <FormItem top={field.title} bottom={field.error}
                         status={field.error ? 'error' : ''}>
            <NativeSelect disabled={field.disabled}
                          style={{
                              zIndex: 6,

                              height: '30px',

                          }}
                          value={field.value ?? (field.nullValue ?? 0)}

                          onChange={e => this.onFieldChange(e, fieldName)}
            >
                {Object.keys(field.options).map((itemP, indexP) => (
                    itemP !== 'null' ?
                        <option value={itemP}>{field.options[itemP]}</option> : ''
                ))}</NativeSelect>
        </FormItem>
    }

    renderCheckbox = (fieldName, field) => {

        return <FormItem bottom={field.error}
                         status={field.error ? 'error' : ''}>
            <SimpleCell Component="label" multiline style={{maxWidth: '250px'}}
                        after={<Switch size={10} checked={field.value} disabled={field.disabled}
                                       onChange={e => this.onFieldChange(e, fieldName)}/>}>
                {field.title}
            </SimpleCell>
        </FormItem>
    }


    renderAfterFields = () => null

    renderFields = () => {
        const {fields} = this.state

        return <FormLayout>
            {Object.keys(fields).map(fieldName => {
                if (fields[fieldName].type == 'checkbox') {
                    return this.renderCheckbox(fieldName, fields[fieldName])
                }
                if (fields[fieldName].type == 'TextArea') {
                    return this.renderTextArea(fieldName, fields[fieldName])
                }
                if (fields[fieldName].type == 'SelectObject') {
                    return this.renderSelectObject(fieldName, fields[fieldName])
                }
                if (fields[fieldName].type == 'select') {
                    return this.renderSelect(fieldName, fields[fieldName])
                }
                return this.renderInput(fieldName, fields[fieldName])
            })}
        </FormLayout>
    }

    render() {

        const {item} = this.props
        if (!item) {
            return null
        }

        return <SplitLayout>
            <SplitCol>
                <PanelHeader style={{whiteSpace: "pre-line"}} before={

                    <PanelHeaderButton onClick={() => this.cmdBack()}
                                       key="cmd_back_form"><Icon24BrowserBack/></PanelHeaderButton>}>
                    {item && item.id > 0 ? `${this.props.title} ${item.title}` : this.props.title_new}
                </PanelHeader>
                <Panel>
                    <Div>
                        {this.renderFields()}
                        {this.renderAfterFields()}
                    </Div>
                    <Div className={AdaptivityContext.isMobile ? "action-board" : ''}>
                        <ButtonGroup mode="horizontal" stretched style={{justifyContent: 'end'}}>

                            <Button stretched size={AdaptivityContext.isMobile ? 'm' : 'l'}
                                    style={{maxWidth: '50%'}}
                                    onClick={() => this.cmdBack()}>Отмена</Button>
                            <Button stretched size={AdaptivityContext.isMobile ? 'm' : 'l'}
                                    style={{maxWidth: '50%'}}
                                    onClick={() => this.save()}>Сохранить</Button>
                        </ButtonGroup>
                    </Div>
                </Panel>
            </SplitCol>
        </SplitLayout>
    }

    save = () => {

        let errors = 0

        const {fields} = this.state

        Object.keys(fields).map(fieldName => {
            fields[fieldName].error = ''
        })
        this.setState({fields})


        Object.keys(fields).map(fieldName => {
            if (fields[fieldName] && fields[fieldName].required && !fields[fieldName].value) {
                fields[fieldName].error = `Необходимо заполнить ${fields[fieldName].title}`
                errors++
            }
        })

        this.setState({fields})
        if (errors > 0) return
        const {item} = this.props

        Object.keys(fields).map(fieldName => {
            const field = fields[fieldName]
            if (field.type == 'SelectObject' && field.value) {
                item[fieldName] = field.value.uid
            } else {
                item[fieldName] = field.value
            }
        })

        window.postMessage({
            type: this.props.eventType,
            value: item
        })

        this.doSave(item)
    }
    doSave = (item) => {

    }
}

export default BaseForm